<template>
  <div
    class="pp-tabs-row"
    role="tablist"
  >
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      class="tab"
      :class="{ on: tab.id === activeId }"
      role="tab"
      :aria-selected="tab.id === activeId"
      @click="$emit('select', tab.id)"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
export type TabDef = { id: string; label: string };

defineProps<{
  tabs: TabDef[];
  activeId: string;
}>();

defineEmits<{
  (e: 'select', id: string): void;
}>();
</script>

<style scoped lang="scss">
.pp-tabs-row {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 18px;
  border-bottom: 1px solid rgba(13, 15, 21, 0.08);
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .tab {
    padding: 14px 18px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(13, 15, 21, 0.62);
    position: relative;
    transition: color 0.15s ease;
    white-space: nowrap;
    background: none;
    border: none;
    cursor: pointer;

    &:hover {
      color: #0d0f15;
    }

    &.on {
      font-weight: 700;
      color: #0d0f15;

      &::after {
        content: '';
        position: absolute;
        inset-inline-start: 12px;
        inset-inline-end: 12px;
        bottom: -1px;
        height: 2px;
        background: #0d0f15;
      }
    }
  }
}
</style>
